import React, { Component } from "react";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
// import firebaseui from 'firebaseui';
import "./Header.css";

class Header extends Component {
  googleSignin() {
    const firebase = this.props.firebase;
    const provider = new firebase.auth.GoogleAuthProvider();
    // provider.addScope('https://www.googleapis.com/auth/plus.login');
    provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
    provider.addScope("https://www.googleapis.com/auth/plus.me");
    provider.addScope("https://www.googleapis.com/auth/userinfo.email");
    // provider.setCustomParameters({
    //   'login_hint': 'user@example.com'
    // });

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function(result) {
        console.dir(result);
        // This gives you a Google Access Token. You can use it to access the Google API.
        // const token = result.credential.accessToken;
        // The signed-in user info.
        const user = result.user;
      })
      .catch(function(error) {
        console.error(error.message);
        // Handle Errors here.
        // var errorCode = error.code;
        // var errorMessage = error.message;
        // // The email of the user's account used.
        // var email = error.email;
        // // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential;
        // // ...
      });
  }

  signout() {
    this.props.firebase.auth().signOut();
  }

  render() {
    // collapseOnSelect
    return (
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
            <a href="#">Dr. Doggy</a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            {!this.props.user &&
              <MenuItem eventKey={1} onClick={this.googleSignin.bind(this)}>
                Sign in
              </MenuItem>}

            {this.props.user &&
              <NavDropdown
                eventKey={3}
                title={this.props.user.displayName || this.props.user.email}
                id="navdropdown"
              >
                {/*<MenuItem eventKey={3.1}>lol</MenuItem>
                <MenuItem divider />*/}
                <MenuItem eventKey={3.3} onClick={this.signout.bind(this)}>
                  Sign out
                </MenuItem>
              </NavDropdown>}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/Header.js
 **/